import { Link } from "gatsby"
import React, { useState } from "react"

import { FaSearch, FaTags } from "../../../AppReactIcons"
import { Search_InternalLink } from "../../../utils/urls"
import { DarkAppButton, GreenAppButton } from "../../buttons"
import { AskPCOSUserType, iPageContext } from "../../types"
import { ContentSeparator } from "../Utils/ContentSeparator"
import { ArticleImageSection } from "./ArticleImageSection"
import ArticlePageSidePanel from "./ArticlePageSidePanel"
import ArticleRelatedContentPanel from "./ArticleRelatedContentPanel"
import ContentController from "./ContentController"
import FeedbackSection from "./FeedbackSection"
import GlobalTranslationSelection from "./GlobalTranslationSelection"
import { BreadcrumbType } from "./types"

const ArticlePageView: React.FC<{
  pageContext: iPageContext
  globalTranslations: string[] | null | undefined
  onClickBookmark: () => void
  onClickShare: () => void
  onClickDiscussion: () => void
  bookmarked: boolean | null
  userProfile?: AskPCOSUserType | null
  breadcrumbs?: BreadcrumbType[]
}> = ({
  pageContext,
  globalTranslations,
  onClickBookmark,
  bookmarked,
  onClickShare,
  breadcrumbs,
  onClickDiscussion,
  userProfile,
}) => {
  const { data } = pageContext

  const [language, setLanguage] = useState<string | undefined>(undefined)
  return (
    <>
      <div className="grid grid-cols-4">
        <div className="hidden xl:block">
          <ArticlePageSidePanel
            onClickDiscussion={onClickDiscussion}
            breadcrumbs={breadcrumbs}
            bookmarked={bookmarked}
            onClickBookmark={onClickBookmark}
            pageContext={pageContext}
            onClickShare={onClickShare}
          />
        </div>
        <div className="col-span-4 xl:col-span-3 text-site-blue-dark">
          <div className="xl:pl-6 xl:pr-12">
            <ArticleImageSection src={data.thumbnail} />
          </div>

          <div className="py-8 px-4 sm:px-12 xl:pr-12 xl:pl-6">
            {breadcrumbs && (
              <>
                <div className="flex items-center flex-wrap justify-between">
                  <div className="flex items-center flex-wrap ">
                    <div className="mr-2 mb-3">
                      <Link to={Search_InternalLink}>
                        <GreenAppButton
                          title="Search all articles"
                          Icon={<FaSearch />}
                        />
                      </Link>
                    </div>
                    <div className=" md:hidden mb-3">
                      <GlobalTranslationSelection
                        languages={globalTranslations}
                        selectedLanguage={language}
                        updateSelectedLanguage={setLanguage}
                      />
                    </div>
                    <div className="mb-3">
                      <Link to={breadcrumbs[breadcrumbs.length - 1].link}>
                        <DarkAppButton
                          title={breadcrumbs[breadcrumbs.length - 1].title}
                          Icon={<FaTags />}
                        />
                      </Link>
                    </div>
                  </div>

                  <div className="hidden md:flex mb-3 ">
                    <GlobalTranslationSelection
                      languages={globalTranslations}
                      selectedLanguage={language}
                      updateSelectedLanguage={setLanguage}
                    />
                  </div>
                </div>
                <div className="pt-1" />
              </>
            )}

            <br></br>

            <ContentController
              onClickDiscussion={onClickDiscussion}
              bookmarked={bookmarked}
              pageContext={pageContext}
              data={data.content}
              defaultLanguage={language}
              onClickShare={onClickShare}
              onClickBookmark={onClickBookmark}
            />

            <FeedbackSection
              reference={pageContext.data.slug}
              userProfileExists={Boolean(userProfile)}
            />
            <ArticleRelatedContentPanel pageContext={pageContext} />
          </div>
        </div>
      </div>
    </>
  )
}

export default ArticlePageView
